import { render } from "./SearchInput.vue?vue&type=template&id=06ee169c"
import script from "./SearchInput.vue?vue&type=script&lang=js"
export * from "./SearchInput.vue?vue&type=script&lang=js"

import exportComponent from "/Users/taylor/Documents/Code/laravel-nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"SearchInput.vue"]])

export default __exports__